import React from 'react';
import Card from '@material-ui/core/Card';
import IconButton from '@material-ui/core/IconButton';
import CardHeader from '@material-ui/core/CardHeader';
import ViewComfy from '@material-ui/icons/ViewComfy';
import CardContent from '@material-ui/core/CardContent';
import InputComp from '../InputComp';
import Button from '@material-ui/core/Button';
import CardActions from '@material-ui/core/CardActions';
import Snackbar from '@material-ui/core/Snackbar';
import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import Chip from '@material-ui/core/Chip';

const BrandsForm = (props) => {
  const {handleImageInput, storeTemporaryBrandImage, tempImage, clearTempUploadedProductBrand} = props;
  return (
    <div className="col-md-12">
      <Card>
        <CardHeader
          avatar={
            <IconButton>
              <ViewComfy/>
            </IconButton>
          }
          title="Create new brand"
        />
        <CardContent>
          <div className="col col-lg-4 offset-lg-3">
            <form id="form-brand" className="form-horizontal" onSubmit={props.handleSubmit}>
              <InputComp Value={props.name} Label="Name" Name="name" Type="text"
                         Required={true}
                         fullWidth={true} margin={'normal'}
                         placeholder="name"
                         PropHandleInputChange={(evt) => props.setField(evt.target.name, evt.target.value)} />
              <Button variant="contained" color="default" style={{
                marginTop: 10,
              }}>
                Upload logo
                <CloudUploadIcon  />
                <input
                  type="file"
                  required
                  accept="image/x-png,image/gif,image/jpeg"
                  onChange={(evt) =>
                    props.handleImageInput(evt, storeTemporaryBrandImage)}
                  style={{
                    cursor: 'pointer',
                    position: 'absolute',
                    top: 0,
                    bottom: 0,
                    right: 0,
                    left: 0,
                    width: '100%',
                    opacity: 0,
                  }} />
              </Button>
              <div style={{marginTop: 5}}>
                {tempImage && tempImage.name ?
                  <Chip
                    label={tempImage.name}
                    onDelete={() => {
                      props.handleImageInput(undefined, undefined);
                      props.clearTempUploadedProductBrand()
                    }}
                  /> : null
                }
              </div>
            </form>
          </div>
          <CardActions>
            <Button
              disabled={!props.name || !tempImage}
              color="primary"
              variant="contained"
              form="form-brand"
              type="submit">Create</Button>
          </CardActions>
        </CardContent>
      </Card>
      <Snackbar
        open={props.formWarningOpen}
        message={props.formWarningOpen}
        autoHideDuration={6000}
      />
    </div>
  );
};

export default BrandsForm;



// WEBPACK FOOTER //
// ./src/components/Brands/brandsForm.js